import { render, staticRenderFns } from "./TopicMap.vue?vue&type=template&id=53f38505&scoped=true"
import script from "./TopicMap.vue?vue&type=script&lang=js"
export * from "./TopicMap.vue?vue&type=script&lang=js"
import style0 from "./TopicMap.vue?vue&type=style&index=0&id=53f38505&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f38505",
  null
  
)

export default component.exports